import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader"; // Ensure the correct path
import { useNavigate } from "react-router-dom";
import Calling from "../../api/Calling"; // Replace with actual API calling function
import { FiLock, FiDownload, FiEye, FiEyeOff, FiCheck } from "react-icons/fi";

export default function NewPw() {
    const [loader, setLoader] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        setLoader(true);
        e.preventDefault();

        // Validate password length
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters long", {
                autoClose: 2000,
            });
            setLoader(false);
            return;
        }

        // Validate password match
        if (password !== confirmPassword) {
            toast.error("Passwords do not match", {
                autoClose: 2000,
            });
            setLoader(false);
            return;
        }

        const body = {
            password: password,
        };

        try {
            const resp = await Calling.ResetPassword(body); // Replace with actual API call for password reset
            const { status, message } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                setTimeout(() => {
                    localStorage.removeItem('forgetPw');
                    navigate("/admin/panel/login"); // Replace with the actual route after password reset
                }, 2000);
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {loader && <Loader />}
            <title>New Password | Video Download</title>

            <div className="min-h-screen w-full flex items-center justify-center bg-main-bg relative overflow-hidden">
                {/* Background Decorative Elements */}
                <div className="absolute top-0 left-0 w-72 h-72 bg-main-blue/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-main-blue/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl"></div>
                <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-main-blue/5 rounded-full blur-2xl"></div>

                <div className="w-full max-w-md mx-4 relative z-10">
                    {/* Logo/Brand Section */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-main-blue to-red-600 rounded-2xl shadow-lg shadow-main-blue/30 mb-4">
                            <FiDownload className="text-main-white text-3xl" />
                        </div>
                        <h1 className="text-2xl font-bold text-main-font">Video Download</h1>
                        <p className="text-main-subfont text-sm mt-1">Admin Control Panel</p>
                    </div>

                    {/* New Password Card */}
                    <div className="bg-main-white rounded-2xl shadow-xl shadow-main-blue/10 border border-main-border/50 overflow-hidden">
                        {/* Card Header */}
                        <div className="bg-gradient-to-r from-main-blue to-red-500 px-6 py-5">
                            <h2 className="text-xl font-semibold text-main-white">Set New Password</h2>
                            <p className="text-white/80 text-sm mt-1">Create a strong password for your account</p>
                        </div>

                        {/* Form Section */}
                        <form onSubmit={handleSubmit} className="p-6 space-y-5">
                            {/* New Password Field */}
                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-main-font mb-2">
                                    New Password
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FiLock className="text-main-subfont" />
                                    </div>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full pl-10 pr-12 py-3 border border-main-border rounded-xl bg-main-bg text-main-font placeholder-main-subfont focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue transition-all duration-200 outline-none"
                                        placeholder="Enter new password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-main-subfont hover:text-main-font transition-colors"
                                    >
                                        {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                    </button>
                                </div>
                                <p className="text-main-subfont text-xs mt-2">
                                    Must be at least 6 characters long
                                </p>
                            </div>

                            {/* Confirm Password Field */}
                            <div>
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-main-font mb-2">
                                    Confirm Password
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FiCheck className="text-main-subfont" />
                                    </div>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        className="w-full pl-10 pr-12 py-3 border border-main-border rounded-xl bg-main-bg text-main-font placeholder-main-subfont focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue transition-all duration-200 outline-none"
                                        placeholder="Confirm new password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-main-subfont hover:text-main-font transition-colors"
                                    >
                                        {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                    </button>
                                </div>
                                {confirmPassword && password && (
                                    <p className={`text-xs mt-2 ${password === confirmPassword ? 'text-green-600' : 'text-main-delete'}`}>
                                        {password === confirmPassword ? '✓ Passwords match' : '✗ Passwords do not match'}
                                    </p>
                                )}
                            </div>

                            {/* Submit Button */}
                            <button
                                type="submit"
                                disabled={loader}
                                className="w-full bg-gradient-to-r from-main-blue to-red-500 text-main-white py-3.5 px-4 rounded-xl font-semibold hover:from-red-600 hover:to-main-blue focus:outline-none focus:ring-2 focus:ring-main-blue/50 focus:ring-offset-2 transition-all duration-300 shadow-lg shadow-main-blue/25 hover:shadow-main-blue/40 disabled:opacity-70 disabled:cursor-not-allowed transform hover:-translate-y-0.5 active:translate-y-0"
                            >
                                {loader ? (
                                    <span className="flex items-center justify-center gap-2">
                                        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                        Resetting...
                                    </span>
                                ) : (
                                    "Reset Password"
                                )}
                            </button>
                        </form>

                        {/* Footer */}
                        <div className="px-6 py-4 bg-main-th/50 border-t border-main-border/50">
                            <p className="text-center text-sm text-main-subfont">
                                Your password will be updated securely
                            </p>
                        </div>
                    </div>

                    {/* Bottom Text */}
                    <p className="text-center text-main-subfont text-sm mt-6">
                        © {new Date().getFullYear()} Video Download Admin Panel
                    </p>
                </div>
            </div>
        </>
    );
}